import { FC, useCallback, useState } from "react";
import classes from './adminTransactions.module.scss'
import { adminService, ITransactionsAdmin } from "../../../../entities/admin";
import { MyError } from "../../../../shared/lib/error/MyError";
import { AuthError } from "../../../../shared/lib/error/AuthError";
import { useMyActions } from "../../../../entities/my";
import { useGlobalMessageActions } from "../../../../entities/globalMessage";
import { LoaderSpinner } from "../../../../shared/ui/spinner";
import { Calendar } from "../../../../shared/ui/calendar";
import { getDateUTC } from "../../../../shared/lib/helpers/getDateUTC";
import { Table } from "../table/Table";
import { Items } from "../items/Items";

interface IProps {
    embedded?: boolean
}

export const AdminTransactions: FC<IProps> = ({embedded = false}) => {

    const [transactions, setTransactions] = useState<ITransactionsAdmin[] | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const {setIsAuth} = useMyActions()
    const {setGlobalMessage} = useGlobalMessageActions()
    const [count, setCount] = useState<number>(0)   

    const getData = async (from: string, to: string) => {
        try{
            setIsLoading(true)
            const transactionsRes = await adminService.getTransactions(from, to)
            setTransactions(transactionsRes.transactions)
            setCount(transactionsRes.transactions_count)
        }
        catch(e){
            console.log(e)
            if(e instanceof AuthError){
                setIsAuth(false)
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else if(e instanceof MyError){
                setGlobalMessage({message: e.message, type: 'error'})
            }
            else{
                setGlobalMessage({message: 'Ошибка при получении списка транзакций', type: 'error'})
            }
        }
        finally{
            setIsLoading(false)
        }
    }
    
    const setDate = useCallback((startDate: Date | null, endDate: Date | null) => {
        if(startDate && endDate){
            getData(getDateUTC(startDate), getDateUTC(endDate))
        }
    }, [])
    
    return (
        <section className={classes.container}>
            {
                !embedded &&
                <section className={classes.title}>Транзакции</section>
            }
            <Calendar onDateRangeSelect={setDate} />
            {
                isLoading
                    ?
                <section className={classes.loader}><LoaderSpinner /></section>
                    :
                transactions
                    &&
                <>
                {
                    !isLoading  
                        &&
                    <section className={classes.count}>Кол-во транзакций: {count}</section>
                }
                {
                    transactions.length
                        ?
                    <>
                        <Table transactions={transactions} />
                        <Items transactions={transactions} />
                    </>
                        :
                    <section className={classes.empty}>Транзакции за выбранный период не найдены</section>
                }
                </>
            }
        </section>
    )
}
